@if (category()) {
  <div data-test="product-icon">
    <img
      [src]="category() | categoryIconSrc"
      [style.max-width]="maxWidth()"
      [style.min-width]="maxWidth()"
      alt="{{ category() | translateCategory }}"
      aria-hidden="true"
      class="w-auto h-auto mb-2"
      data-test="product-category-img"
    />
    @if (showText()) {
      <div [outerHTML]="heading()"></div>
      @switch (textNodeType()) {
        @case ('h1') {
          <h1
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </h1>
        }
        @case ('h2') {
          <h2
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </h2>
        }
        @case ('h3') {
          <h3
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </h3>
        }
        @case ('h4') {
          <h4
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </h4>
        }
        @case ('h5') {
          <h5
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </h5>
        }
        @case ('h6') {
          <h6
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </h6>
        }
        @case ('p') {
          <p
            [style.font-size]="fontSize"
            class="mb-0 h6"
            data-test="product-category-text"
            [ngClass]="{ 'd-lg-none': hideCategoryTextOnDesktop() }"
          >
            {{ category() | translateCategory }}
          </p>
        }
      }
    }
  </div>
}
